import React from 'react';

import {publish} from '@stubhub/pubsub-utils';
import {CookieModalCore} from '@stubhub/react-cookie-modal-core';

import TrackListener from './TrackListener';
import {COOKIE_MODAL_EVENTS} from './utils/track-events';

const CookieModal = (props) => {
  const handleSubmit = (cookieValues) => {
    publish(COOKIE_MODAL_EVENTS.SET_VALUES, {values: cookieValues});
  };

  return (
    <>
      <TrackListener />
      <CookieModalCore onSubmit={handleSubmit} {...props} />
    </>
  );
};

CookieModal.displayName = 'CookieModal';

export default CookieModal;
